import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import AdminSalary from "./AdminSalary";
import KhattabatCapacity from "./KhattabatCapacity";
import SideBarMenu from "./SideBarMenu";
import UserInfo from "./UserInfo";

const SideBarContent = withLiteObserverAndTheme<{ onNavigate: () => void }>(
  (props) => {
    const { onNavigate } = props;

    return (
      <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100%" }}>
        <UserInfo />
        <Stack spacing={1} sx={{ px: 2, pb: 2, "&:empty": { pb: 0 } }}>
          <KhattabatCapacity />
          <AdminSalary />
        </Stack>
        <Divider />
        <SideBarMenu onNavigate={onNavigate} />
      </Box>
    );
  }
);
export default SideBarContent;
